export const selectionTypes = {
  specific: 'specific',
  timeslot: 'timeslot',
  multiple: 'multiple',
};
